<div *ngIf="storageToken()"
    class="relative flex justify-center w-fit items-center gap-1.5 rtl:ml-3 ltr:mr-1 rtl:sm:ml-5 ltr:sm:mr-5">
    <div class="w-32 h-7 mb-[-10px] rounded-md overflow-hidden border-[0.1rem] border-lightMode-200 dark:border-darkMode-700 ngSkeleton-squared hidden md:block ease-in-out duration-150"
    *ngIf="!account()?.first_name && !account()?.last_name">    
        <ngx-skeleton-loader
                [theme]="{'width': '100%' , 'height' : '100%' , 'background-color' : 'transparent'}"
                appearance="line" count="1" class="ngSkeleton-squared h-full w-full">
        </ngx-skeleton-loader>
    </div>
    <p (click)="changeProfileState()" class="cursor-pointer text-darkMode-100 hidden md:block text-[0.8rem] font-bold">
        {{account()?.first_name}} {{account()?.last_name}}
    </p>
    <div (click)="changeProfileState()" class="flex gap-1 justify-center items-center w-fit cursor-pointer">
        <button
        [class]="account()?.last_logined_role=='USER'?'rounded-full':'rounded-[3px]'"
        class="flex w-8 h-8  overflow-hidden border-[0.1rem] border-darkMode-700 focus:border-2 focus:border-lightMode-500 ngSkeleton-squared dark:focus:border-darkMode-100 ease-in-out duration-150"
        aria-label="desktop-header-profile-logo">
        <ngx-skeleton-loader
            [theme]="{'width': '100%' , 'height' : '100%' , 'background-color' : 'transparent'}"
            appearance="line" count="1" class="ngSkeleton-squared h-full w-full"
            [hidden]="imageObject('entityHeaderLogo'+account()?.profile_photo)">
        </ngx-skeleton-loader>
        <img
            (load)="loadImage('entityHeaderLogo'+account()?.profile_photo)"
            [hidden]="!imageObject('entityHeaderLogo'+account()?.profile_photo)"
            *ngIf="account()?.profile_photo"
            [src]="account()?.profile_photo"
            alt="profile image"
            [class]="account()?.last_logined_role=='USER'?'rounded-full':'rounded-[3px]'"
            [class]="account()?.last_logined_role=='ORGAN'?'bg-white':''"
            class="w-full h-full">
        <img
            (load)="loadImage('entityHeaderLogo'+account()?.profile_photo)"
            [hidden]="!imageObject('entityHeaderLogo'+account()?.profile_photo)"
            *ngIf="!account()?.profile_photo"
            [src]="handleImageDefualt(account()?.last_logined_role == 'ORGAN' ?'organ':'hamafarin',account()?.gender)| async"
            alt
            class="w-full h-full"
            [class]="mainImage != 'assets/image/default.webp' ? 'scale-[80%]':''"
            aria-labelledby="#desktop-header-profile-logo">
        </button>
        <div class="flex">
            <mat-icon fontIcon="arrow_drop_down" class="cursor-pointer w-fit text-darkMode-100 h-fit flex justify-center items-center"></mat-icon>
        </div>
    </div>
    <button [class]="profileClass" (click)="changeProfileState()"
        class="fixed inset-0 w-full h-full ease-in-out cursor-default"
        aria-label="change-profile-state">
    </button>
    <div [class]="profileClass"
        class="w-64 top-8 rtl:left-0 ltr:right-0 absolute bg-lightHeaderBG dark:bg-darkHeaderBG border border-lightMode-300 dark:border-darkMode-700 mt-2 rounded-md overflow-hidden opacity-0 ease-in-out duration-150 overflow-y-scroll no-scrollbar shadow-site shadow-lightMode-500 dark:shadow-darkMode-700"
        id="profileDropdown" style="max-height: calc(100vh - 3.55rem);">
        <div class="flex flex-col w-full">
            <!-- border-b -->
            <div
                class="profile-info-section flex flex-col p-2  border-lightMode-300 dark:border-darkMode-700 mb-2">
                <div class="profile-header flex justify-start"
                    [class]="!account()?.profile_text ? 'items-center':'items-start'">
                    <a (click)="changeProfileState()"
                        [routerLink]="[accountUrl()]" class="profile-photo">
                        <div
                            class="my-auto w-14 h-14 ngSkeleton-squared overflow-hidden"
                            [class]="account()?.last_logined_role=='USER'?'rounded-full':'rounded-[3px]'">
                            <ngx-skeleton-loader
                                [theme]="{'width': '100%' , 'height' : '100%' , 'background-color' : 'transparent'}"
                                appearance="line" count="1"
                                class="ngSkeleton-squared h-full w-full"
                                [hidden]="imageObject('entityHeaderModalLogo'+account()?.profile_photo)"></ngx-skeleton-loader>
                            <img
                                (load)="loadImage('entityHeaderModalLogo'+account()?.profile_photo)"
                                [hidden]="!imageObject('entityHeaderModalLogo'+account()?.profile_photo)"
                                class=" w-full h-full"
                                *ngIf="account()?.profile_photo"
                                [src]="account()?.profile_photo"
                                [title]="account()?.first_name+' '+account()?.last_name"
                                [class]="account()?.last_logined_role=='ORGAN'?'bg-white':''"
                                [alt]="account()?.first_name+' '+account()?.last_name">
                            <img
                                (load)="loadImage('entityHeaderModalLogo'+account()?.profile_photo)"
                                [hidden]="!imageObject('entityHeaderModalLogo'+account()?.profile_photo)"
                                *ngIf="!account()?.profile_photo"
                                [src]="handleImageDefualt(account()?.last_logined_role == 'ORGAN' ?'organ':'hamafarin',account()?.gender)| async"
                                [alt]="account()?.first_name+' '+account()?.last_name"
                                class="w-full h-full"
                                [class]="mainImage != 'assets/image/default.webp' ? 'scale-[80%]':''">
                        </div>
                    </a>
                    <div class="rtl:pr-2 ltr:pl-2 w-[calc(100%-72px)]">
                        <div class="title-color text-sm font-semibold">
                            <a (click)="changeProfileState()"
                                [routerLink]="[accountUrl()]">
                                <span>
                                    {{account()?.first_name}}
                                    {{account()?.last_name}}
                                </span>
                                <!-- <mat-icon aria-hidden="true" data-mat-icon-type="font" *ngIf="getCurrentAccountData()?.is_verified && getCurrentAccountData()?.first_name" class="material-symbols-outlined mx-2 verified mt-1 text-2xl activeText">
                                    verified
                                </mat-icon> -->
                            </a>
                        </div>
                        <div class="muted-color text-xs mt-1">
                            <a (click)="changeProfileState()"
                                [routerLink]="[accountUrl()]">
                                {{account()?.profile_text}}
                            </a>
                        </div>
                    </div>
                    <mat-icon aria-hidden="true" data-mat-icon-type="font"
                        [class]="isExpand?'rotate-180 ml-1 mt-0.5':'rotate-0 '"
                        (click)="expandPanelAccount()"
                        *ngIf="organs().length>0 && organs()!=null"
                        class="material-symbols-outlined  transition-all duration-300 mat-center cursor-pointer muted-color text-darkMode-300 dark:text-darkMode-200 text-inherit text-[1.1rem]"
                        aria-labelledby="#destop-home-button">
                        expand_more
                    </mat-icon>
                </div>
                <div
                    class="overflow-y-scroll scroll-horizontal-list ease-in-out duration-300 max-h-0 "
                    [class]="expandAccountClass">
                    <div
                        *ngIf="account()?.last_logined_role!='USER'"
                        class="profile-header mt-3 flex items-center">
                        <a
                            (click)="switchAccount(user()?.username,'USER')"
                            (click)="changeProfileState()"
                            class="profile-photo cursor-pointer">
                            <div
                                class="my-auto rounded-full w-8 h-8 overflow-hidden ngSkeleton-squared">
                                <img
                                    class=" w-full h-full rounded-full"
                                    *ngIf="user()?.profile_photo"
                                    [src]="user()?.profile_photo"
                                    [title]="user()?.first_name+' '+user()?.last_name"
                                    [alt]="user()?.first_name+' '+user()?.last_name">
                                <img
                                    *ngIf="!user()?.profile_photo"
                                    [src]="handleImageDefualt('hamafarin',account()?.gender)| async"
                                    [alt]="user()?.first_name+' '+user()?.last_name"
                                    [title]="user()?.first_name+' '+user()?.last_name"
                                    class="w-full h-full"
                                    [class]="userImage != 'assets/image/default.webp' ? 'scale-[80%]':''">

                            </div>
                        </a>
                        <div class="rtl:pr-2 ltr:pl-2">
                            <div class="title-color text-xs font-semibold">
                                <a
                                    (click)="switchAccount(user()?.username,'USER')"
                                    (click)="changeProfileState()"
                                    class="cursor-pointer">
                                    {{user()?.first_name}}
                                    {{user()?.last_name}}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngFor="let organ of organs()">
                        <div
                            *ngIf="organ?.username!=account()?.username"
                            class="profile-header mt-3 flex items-center">
                            <a
                                (click)="switchAccount(organ?.username,'ORGAN',organ)"
                                (click)="changeProfileState()"
                                class="profile-photo cursor-pointer">
                                <div
                                    class="my-auto rounded-[3px] w-8 h-8 overflow-hidden">
                                    <img class=" w-full h-full bg-white"
                                        *ngIf="organ?.logo" [src]="organ?.logo"
                                        [title]="organ?.name"
                                        [alt]="organ?.name">
                                    <img class=" w-full h-full"
                                        *ngIf="!organ?.logo"
                                        [src]="handleImageDefualt('organ') |async"
                                        [title]="organ?.name"
                                        [alt]="organ?.name">
                                </div>
                            </a>
                            <div class="rtl:pr-2 ltr:pl-2">
                                <div class="title-color text-xs font-semibold">
                                    <a
                                        (click)="switchAccount(organ?.username,'ORGAN',organ)"
                                        (click)="changeProfileState()"
                                        class="cursor-pointer">
                                        {{organ?.name}}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a [routerLink]="editPage(accountUrl())"
                    (click)="changeProfileState()" type="button"
                    class="mt-3 inline-block px-6 py-1 border-2 border-blue-500 text-blue-600 dark:text-blue-100 font-medium text-xs leading-tight uppercase rounded-full hover:bg-blue-500 text-center hover:border-blue-600 dark:hover:border-blue-400 hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out cursor-pointer select-none"
                    aria-label="open-profile-from-header">
                    {{(checkAccountIsOrgan()|async) ? 'ویرایش اطلاعات موسسه' :
                    'ویرایش رزومه' }}
                </a>
            </div>
            <div
                class="account-section flex flex-col border-lightMode-300 dark:border-darkMode-700 px-2">
                <p *ngIf="!(isOrganObs()|async)&& account()?.username == 'nrh-4c99l9lj4g'"
                    class="title-color text-sm font-semibold mb-1 m-1">
                    ایجاد
                </p>
                <!-- <a routerLink="/katibe/create" (click)="scrollToViewNavigate()" (click)="changeProfileState()" class="muted-color flex items-center text-xs mt-1 ">
                    <mat-icon aria-hidden="true" data-mat-icon-type="font"  class="material-symbols-outlined muted-color text-darkMode-300 dark:text-darkMode-200 text-inherit text-[1.1rem] mat-center rtl:mr-1 ltr:ml-1" aria-labelledby="#destop-home-button">
                        add
                    </mat-icon>
                    <span class="">مجله جدید</span>
                </a> -->
                <a *ngIf="!(isOrganObs()|async) && account()?.username == 'nrh-4c99l9lj4g'" routerLink="/organ/create"
                    (click)="scrollToViewNavigate()"
                    (click)="changeProfileState()"
                    class="muted-color flex items-center text-xs mt-1 -mr-1">
                    <mat-icon aria-hidden="true" data-mat-icon-type="font"
                        class="material-symbols-outlined muted-color text-darkMode-300 dark:text-darkMode-200 font-normal text-inherit text-[0.9rem] mat-center"
                        aria-labelledby="#destop-home-button">
                        add
                    </mat-icon>
                    <span class>موسسه جدید</span>
                </a>

                <p
                    class="title-color text-sm font-semibold my-1 border-t border-lightMode-300 dark:border-darkMode-700 p-1 pt-2 mt-1">
                    حساب کاربری
                </p>
                <a (click)="changeProfileState()"
                    (click)="scrollToViewNavigate()"
                    (click)="removeWalletStorage()"
                    [routerLink]="[profileUrl(), 'setting','wallet']"
                    class="muted-color text-xs mb-[7px] px-2 hover-underline flex items-center justify-between">
                    <span>اعتبار کیف پول</span>
                    <p
                        class="text-blue-500 dir-ltr flex items-center font-extrabold no-underline">
                        <span>تومان</span>
                        &nbsp;<span>{{balancedValue|convertToPersian}}</span>
                    </p>
                </a>
                <a *ngIf="checkRoleIsPerson()"
                    (click)="changeProfileState()"
                    (click)="scrollToViewNavigate()"
                    [routerLink]="[profileUrl(), 'setting']"
                    class="muted-color text-xs my-1 px-2 hover-underline">
                    تنظیمات و حریم‌خصوصی
                </a>
                <!--<a href="" (click)="changeProfileState()" class="muted-color text-xs mt-1 hover-underline">
                    راهنما
                </a>
                <a href="" (click)="changeProfileState()" class="muted-color text-xs mt-1 hover-underline">
                    زبان
                </a> -->
            </div>
            <!-- <div class="manage-section  flex flex-col p-2 border-b border-lightMode-300 dark:border-darkMode-700">
                <a routerLink="" (click)="changeProfileState()" class="title-color text-sm font-semibold mb-1">
                    مدیریت
                </a>
                <a href="" (click)="changeProfileState()" class="muted-color text-xs mt-1 hover-underline">
                    پست‌ها و فعالیت‌ها
                </a>
                <a href="" (click)="changeProfileState()" class="muted-color text-xs mt-1 hover-underline">
                    فرصت‌های شغلی
                </a>
            </div> -->
            <!-- <a  class="sign-out-section muted-color hover-underline text-sm p-2 rtl:pr-0 ltr:pl-0">
                تنظیمات و امنیت
            </a> -->
            <a (click)="logout()" (click)="changeProfileState()"
                class="sign-out-section muted-color cursor-pointer hover-underline title-color text-sm border-t border-lightMode-300 dark:border-darkMode-700 p-1 pt-2 pb-1 mb-1 mt-2 rtl:pr-3 ltr:pl-3">
                خروج از حساب کاربری
            </a>
        </div>
    </div>
</div>

<div *ngIf="!storageToken()"
    class="flex items-center mx-1 md:rtl:ml-5 md:ltr:mr-5">
    <div
        class="border-0 md:border-2 border-darkMode-700  rounded-full overflow-hidden flex items-center ml-2 md:ml-0">
        <a (click)="skipChangeUrl('/auth/login')"
            (click)="scrollToViewNavigate()" matRipple routerLink="auth/login"
            class="text-darkMode-100 hover:activeText dark:hover:activeText w-12 h-12 md:w-fit md:h-fit hover:ease-in-out duration-200 px-2 py-1 md:ml-0 md:py-2 md:px-3 flex justify-center items-center text-sm z-0"
            aria-label="desktop-header-login-button">
            <span class="text-inherit hidden md:flex">ورود</span>
            <i
                class="fas fa-sign-in-alt text-inherit md:mr-2 text-xl md:text-lg auth-font-icon"></i>
        </a>
        <a (click)="skipChangeUrl('/auth/signup')"
            (click)="scrollToViewNavigate()" matRipple routerLink="auth/signup"
            class="rtl:border-r ltr:border-l border-lightMode-500 hover:activeText hover:ease-in-out duration-200 rtl:pl-3 ltr:pr-3 rtl:pr-2 ltr:pl-2 py-2 md:py-2 text-darkMode-100 dark:hover:activeText hidden md:flex items-center z-10 text-sm h-12"
            aria-label="desktop-header-signup-button">
            ثبت نام
            <i class="fas fa-user-plus text-inherit mr-2 mt-[2px]"></i>
        </a>
    </div>
</div>